<template>
  <div class="TreeSEComponent">
    
    <!-- <p>{{lang.infotext_1}}</p> -->
    <!-- <b-form-input class="searchInput" id="input-search" size="sm" v-model="searchString" :placeholder="lang.placeholder_Search"></b-form-input>
    <br> -->
    <b-form-input id="input-search" v-model="searchString" :placeholder="lang.placeholder_Search" class="input-search"></b-form-input>
    <ul :id="id" class="library_ul">
      <ItemTreeSEDetailsObject v-if="!Array.isArray(reorderedData)"  :searchString="searchString" class="item" :model="reorderedData" :specialParam="specialParam" parentName=""></ItemTreeSEDetailsObject>
      <ItemTreeSEDetailsArray v-if="Array.isArray(reorderedData)"  :searchString="searchString" class="item" :model="reorderedData" :specialParam="specialParam"  parentName=""></ItemTreeSEDetailsArray>
    </ul>
    
    <LoaderComponent  v-if="!isData"></LoaderComponent>

 </div>
</template>

<script>
  import ItemTreeSEDetailsObject from "@/components/shared/ItemTreeSEDetailsObject"
  import ItemTreeSEDetailsArray from "@/components/shared/ItemTreeSEDetailsArray"
  import LoaderComponent from "@/components/shared/LoaderComponent"
  import { mapGetters } from 'vuex'


  export default {
    name: 'TreeSEComponent',
    components: {
        ItemTreeSEDetailsObject,
        ItemTreeSEDetailsArray,
        LoaderComponent
    },
    props:{
        iscategory: Boolean,
        reloadTree: Boolean,
        lang: Object,
        action: Boolean,
        data: Object
    },
    data: function () {
        return {
            open: true,
            dataItem:{},

            id: "treeSE_"+this._uid,
            name:'',
            searchString: "",
            model: {},
            //data: null,
            specialParam: {}
        };
    },
    computed: {

        ...mapGetters({
        
            reloadAfterDeleteTreeItem: 'reloadAfterDeleteTreeItem',
        
        }),
        isData(){


            return this.$store.getters.dataTree.name != ""
        }
    },
    watch: {
            
      reloadAfterDeleteTreeItem: function(new_isData)
      {
        if (new_isData)
        {
            this.loadData();
            this.$store.dispatch("reloadAfterDeleteTreeItem",false )
        }
      },

      
    },
    
    created() {

        
        const preferredKeys = ['SummaryData', 'LifeCycleData', 'RiskData', 'EnvironmentalDto'];

        

        this.reorderedData = this.reorderKeys(this.data, preferredKeys);
        try {
            
            this.specialParam.LifecycleRisk = this.data.RiskData.LifecycleRisk;
        } catch (ex) {
            console.warn(ex)
        }
        
    },
    
    methods: {
      reorderKeys(obj, preferredKeys) {
        const reorderedObject = {};

        preferredKeys.forEach(key => {
            if (obj.hasOwnProperty(key)) {
            reorderedObject[key] = obj[key];
            }
        });

        Object.keys(obj).forEach(key => {
            if (!reorderedObject.hasOwnProperty(key)) {
            reorderedObject[key] = obj[key];
            }
        });

        return reorderedObject;
      }        

    }
  }
</script>


<style lang="scss">
.library_bold {
    font-weight: bold;
  }

  .library_ul label{
    margin-right: 0px;
  }
  .library_li{
    margin-top: 5px;
    margin-left: 0px;
    width: 100%;

  }
  .library_img {
    width: 16px;
    height: 16px;
    margin-right: 5px;
    margin-left: 5px;
  }
  .library_ul {
    padding-left: 18px;
    line-height: 1.5em;
    list-style-type: none;

  }
  .input-search{
    font-size: 0.75rem;
    width: 200px;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/TreeSEComponent.vue